export default __webpack_public_path__ + "static/media/board.min.2839a796.png";